import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const ProfileBukopinAPI = (props) => {
  return axios.get(
    `${env.HOST}/tentang-kami${props}`,
    {
      headers
    }
  );
};
export default ProfileBukopinAPI;
